import React, { useState } from 'react';
import axios from 'axios';
import SearchBar from './SearchBar';
import CustomerInfoCompact from './CustomerInfoCompact';
import LedgerTableCompact from './LedgerTableCompact';
import Header from '../../Header';

export const CustomerWalletLedger = () => {
  const [customerData, setCustomerData] = useState(null);
  const [ledgerData, setLedgerData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (mobile) => {
    if (!mobile || mobile.length !== 10) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }

    setLoading(true);
    setError('');
    setCustomerData(null);
    setLedgerData([]);

    try {
      // Fetch customer details
      const customerResponse = await axios.get(
        `https://ibretailapi.abisaio.com/api/PrestoOrder/GetPrestoCustomerDetailsbyMobile/${mobile}`
      );
      setCustomerData(customerResponse.data);

      // Fetch wallet transactions
      const ledgerResponse = await axios.get(
        `https://ibretailapi.abisaio.com/api/PrestoOrder/GetPrestoWalletTransactionsbyMobile/${mobile}`
      );
      setLedgerData(ledgerResponse.data || []);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Error fetching customer data. Please try again.'
      );
      setCustomerData(null);
      setLedgerData([]);
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    height: 'calc(100vh - 64px)',
    backgroundColor: '#f9fafb',
    padding: '8px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  };

  const searchSectionStyle = {
    flexShrink: 0,
  };

  const errorStyle = {
    padding: '8px',
    backgroundColor: '#fee2e2',
    border: '1px solid #fca5a5',
    color: '#b91c1c',
    fontSize: '14px',
    borderRadius: '4px',
    flexShrink: 0,
  };

  const customerCardStyle = {
    flexShrink: 0,
  };

  const noDataStyle = {
    padding: '16px',
    backgroundColor: '#fffbeb',
    border: '1px solid #fde68a',
    color: '#a16207',
    fontSize: '14px',
    borderRadius: '4px',
  };

  return (<><Header/>

    <div style={containerStyle}>
        
      {/* Search Section */}
      <div style={searchSectionStyle}>
        <SearchBar onSearch={handleSearch} loading={loading} />
      </div>

      {/* Error Message */}
      {error && (
        <div style={errorStyle}>
          {error}
        </div>
      )}

      {/* Customer Details Card */}
      {customerData && (
        <div style={customerCardStyle}>
          <CustomerInfoCompact customerData={customerData} ledgerData={ledgerData} />
        </div>
      )}

      {/* Ledger Table */}
      {customerData && ledgerData.length > 0 && (
        <div >
          <LedgerTableCompact ledgerData={ledgerData} customerData={customerData} />
        </div>
      )}

      {/* No Data Message */}
      {customerData && ledgerData.length === 0 && !loading && (
        <div style={noDataStyle}>
          No wallet transactions found for this customer.
        </div>
      )}
    </div>
    </>
  );
};

export default CustomerWalletLedger;
